export default __webpack_public_path__ + "static/media/Wishlist.522e9967.svg";